import React from "react";
import Box from "@mui/material/Box";
import BoxResponsivePadding from "../../common/boxes/BoxResponsivePadding";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <BoxResponsivePadding>{children}</BoxResponsivePadding>
      )}
    </Box>
  );
}

export default TabPanel;
